var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableCell',{staticClass:"requirements-cell",attrs:{"hSpan":_vm.hSpan,"label":_vm.$t('baseOrderColumns.requirements')}},[_c('OrderRequirements',{attrs:{"order":_vm.order}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }